import http from '../services/http';

export default class Common {
  static fetchInfoStock() {
    return http.get('https://www.alphavantage.co/query?function=TIME_SERIES_DAILY&symbol=CLCI&apikey=OMZMI6O9Z9NYN50L');
  }
}
